import React from "react";
import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import Select from "react-select";
import OrderColumn from "../../../components/Global/OrderColumn";
import useEmployee from "./useEmployee";
import EmployeeMaster from "./EmployeeMaster";
import Style from "./employee.module.scss";
import { Table } from "../../Global/Table";
const Employee = () => {
  const {
    employeeState,
    showEditModal,
    tableFields,
    employeeList,
    rolesList,
    isLoading,
    isFetching,
    paginationOptions,
    isInActive,
    setSelectedId,
    getRow,
    handleEditColumnsClick,
    handleSort,
    handlePagination,
    handleModalClick,
    handleDelete,
    handleActivate,
    handleDeleteModal,
    handleEditAction,
    handleSearch,
    updateEmployeeFields,
    handleClearClick,
    handlePageSize,
    handleRoleChange,
    refetch,
  } = useEmployee();
  return (
    <div>
      <HeadingGroup
        title={"All Employees"}
        className={`pro-mb-4`}
        buttonTitle={employeeList?.data?.create_permission && "Add new"}
        handleClick={handleModalClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="row">
          <div className="col-md-8">
            <div className="d-block" style={{paddingTop: "25px"}} />
            <div className="search-wrap xl">

          <SearchFilters
            onSearchInput={handleSearch}
            showActions={true}
            handleActionClick={handleEditColumnsClick}
            loading={isLoading}
            SearchIcon={
              <span className="material-symbols-outlined"> search </span>
            }
            showClearFilters
            handleClear={handleClearClick}
            searchInputProps={{ value: employeeState?.search,placeholder : "Search First name, Last name, Phone Number, Email" }}
          />
          </div>
          </div>
          <div className="col-md-4">
          <div className="input-wrap" style={{ maxWidth: "300px", marginLeft: "auto" }}>
            
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Filter by Role
          </label>
          <Select
            id="role_filter"
            name="role_filter"
            placeholder="Select Role"
            isClearable
            className="pro-input lg"
            classNamePrefix="pro-input"
            options={rolesList?.data?.data || []}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?._id}
            value={employeeState?.selectedRole}
            onChange={handleRoleChange}
            menuPlacement="auto"
          />
          </div>
          </div>
        </div>
        <Table
          multiSelect={false}
          data={employeeList?.data?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          tableWrapClassName ={Style.tbl_h_xl}
          editIcon={<span className="material-symbols-outlined">edit</span>}
          deleteIcon={
            isInActive ? (
              <span className="material-symbols-outlined">person</span>
            ) : (
              <span className="material-symbols-outlined">person_off</span>
            )
          }
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          clear={employeeState.clearSelection}
          perpage={employeeState?.currentPageSize}
          assignable={false}
          handleSelect={(id) => {
            setSelectedId(id);
          }}
          handleEdit={handleEditAction}
          handleDelete={handleDeleteModal}
          deleteText={isInActive ? "Activate" : "InActivate"}
          deletable={employeeList?.data?.delete_permission}
          editable={employeeList?.data?.edit_permission}
          showCheckBox={true}
        />
        {employeeList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={employeeState?.currentPage}
            totalPageCount={Math.ceil(
              employeeList.data.total_count / employeeState.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={employeeState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            {isInActive ? (
              <ConfirmationBox
                title={"Are you sure you want to activate the selected user?"}
                subTitle={"This action will activate the user account."}
                cancelText={"No"}
                cancelAction={handleDeleteModal}
                submitText={"Yes"}
                submitAction={handleActivate}
                isRight={true}
              />
            ) : (
              <ConfirmationBox
                title={"Are you sure you want to inactivate the selected employee?"}
                subTitle={"This action will inactivate the user account."}
                cancelText={"No"}
                cancelAction={handleDeleteModal}
                submitText={"Yes"}
                submitAction={handleDelete}
                isRight={true}
              />
            )}
          </div>
        </ModalLayout>

        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={employeeList?.data?.fields}
              moduleId={employeeList?.data?.module_id}
              updateData={updateEmployeeFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={employeeState?.showAddEmployeeModal}
          handleClose={handleModalClick}
          title={employeeState?.isEdit ? "Update Employee" : "Add Employee"}
          closeIcon={<span className="material-symbols-outlined"> close </span>}
          className={Style.offcanvas}
        >
          <EmployeeMaster refetch={refetch}></EmployeeMaster>
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default Employee;
